export class Stack<T> {

    items: T[] = []

    constructor() {
     
    }
  
    push(element: T) {
      this.items.push(element);
    }
  
    pop() {
      if (this.isEmpty()) {
        return undefined
      }
      return this.items.pop();
    }
  
    peek(count = 1) {
      if (this.isEmpty() || count > this.items.length) {
        return undefined
      }
      return this.items[this.items.length - count];
    }
  
    isEmpty() {
      return this.items.length === 0;
    }
  
    size() {
      return this.items.length;
    }

  }